import Vue from 'vue';

if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}
import { initBiPoint } from '../../resource/plugins/biPoint/index';
import App from '../../officialSupportApp.vue';
import router from '../rooters/officialSupport';
import store from '../stores/officialSupport';
import globalConfig from '@utiles/globalConfig';
import clickThrottling from '../../resource/plugins/clickThrottling';
import Modal from '@components/officialSupport/common/Modal.vue';
import Button from '@components/officialSupport/common/Button.vue';
import Back from '@components/officialPassport/common/Back.vue';
import Close from '@components/officialPassport/common/Close.vue';
// vant组件,全局引入
import Vant from 'vant';
import { Lazyload } from 'vant';
import '@vant/touch-emulator';
import 'vant/lib/index.css';
import '@plugins/replaceAllPolyfills';
import 'swiper/css/swiper.css'; // 用到轮播再打开

initBiPoint({ dataLayerName: 'csorderDataLayer', sendSessionEnd: true });

Vue.use(Vant);
Vue.use(Lazyload);

// 设置点击节流.
Vue.use(clickThrottling);
clickThrottling.setThrottlingTime(800);
Vue.config.productionTip = true;

globalConfig.setVuePrototypePlatformConfig(Vue);

Vue.component('Button', Button);
Vue.component('Modal', Modal);
Vue.component('Back', Back);
Vue.component('Close', Close);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#officialSupport');
